import PropTypes from 'prop-types';
import deprecatedProp from '../utils/deprecated_prop';
var propTypes = {
  appearance: PropTypes.oneOf(['dropShadow', 'outlined']),
  centerArea: PropTypes.node,
  className: PropTypes.string,
  customStyle: PropTypes.any,
  leadingArea: PropTypes.node,
  leftArea: deprecatedProp(PropTypes.node, "Use `leadingArea` on Header root instead."),
  position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky']),
  responsiveLayout: PropTypes.oneOf(['doubleRow', 'singleRow']),
  rightArea: deprecatedProp(PropTypes.node, "Use `trailingArea` on Header root instead."),
  trailingArea: PropTypes.node
};
export default propTypes;